export default {"src":"/_next/static/media/login-b2b-bg.2295daed.svg","height":842,"width":1440};